import { Slot } from "@radix-ui/react-slot";
import type { VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/lib/utils";
import { underV3, v3ButtonClasses } from "../v3/flagged";
import { buttonVariants } from "./constants";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(
          buttonVariants({ variant, size }),
          underV3(v3ButtonClasses(variant, size)),
          className,
        )}
        {...props}
        ref={ref}
      />
    );
  },
);
Button.displayName = "Button";

export { Button };
